// extracted by mini-css-extract-plugin
module.exports = {"content":"Image_content__KKqCw","content__icon":"Image_content__icon__59OYe","content__name":"Image_content__name__ieA_L"};